export default __webpack_public_path__ + "static/5-703edaface0177d0032a7c48d2d27f0c.webp";